<template>
  <div class="pb-5">
    <div class="jm-white-container">
      <form>
        <div class="col-lg-10 mx-auto">
          <div class="row">
            <div class="col-12">
              <div class="h5 mb-3">
                Cinema:
                {{ currentCinemaIndex == 0 ? 1 : currentCinemaIndex }}/{{
                  noOfCinemas
                }}
              </div>
            </div>
            <div class="col-md-6 mb-5">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    v-model="cinema_details.cine_name"
                    type="text"
                    id="cn"
                    v-validate="{
                      required: 'required',
                      regex: /^[a-zA-Z0-9- ]*$/
                    }"
                    placeholder="."
                    name="Cinema Name"
                  />
                  <label for="cn">Cinema Name*</label>
                </div>
                <Tooltip
                  :title="`Name of Cinema. The name should be unique.`"
                />
              </div>
              <p
                v-if="submitted && errors.has('Cinema Name')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"Cinema Name"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    v-model="cinema_details.registration_number"
                    type="text"
                    id="rn"
                    placeholder="."
                    name="registration number"
                    v-validate="{
                      required: 'required',
                      regex: /^[a-zA-Z0-9 ]*$/
                    }"
                  />
                  <label for="rn">Registration No</label>
                </div>
                <Tooltip :title="`Registration number for Cinema`" />
              </div>
              <p
                v-if="submitted && errors.has('registration number')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"registration number"}`) }}
              </p>
              <!-- <p class="error_msg">Registration number for cinema.</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.license_number"
                    id="ln"
                    placeholder="."
                    name="license number"
                    v-validate="'required|alpha_num|min:5|max:30'"
                  />
                  <label for="ln">License No</label>
                </div>
                <Tooltip :title="`License number for cinema`" />
              </div>
              <p
                v-if="submitted && errors.has('license number')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"license number"}`) }}
              </p>
              <!-- <p class="error_msg">Enter valid license number</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.email_id"
                    id="ea"
                    placeholder="."
                    name="EmailAddress"
                    v-validate="'required|email'"
                  />
                  <label for="ea">Email Address</label>
                </div>
                <Tooltip :title="`Email Address for communication`" />
              </div>
              <p
                v-if="submitted && errors.has('EmailAddress')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"EmailAddress"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="SelectedCountryCode"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-50"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in Countries"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('countrycode',countrycode)"
                  >{{ countrycode.country_mob_code }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Countries"
                  :searchable="true"
                  :placeholder="
                    SelectedCountryCode && SelectedCountryCode.length > 0
                      ? SelectedCountryCode
                      : 'Country Code'
                  "
                  label="country_mob_code"
                  track-by="country_id"
                  @select="onSelectHandler('countrycode', $event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.contact_number"
                    id="contno"
                    name="contact_no"
                    v-validate="'required|numeric|min:7|max:12'"
                    placeholder="."
                  />
                  <label for="contno">Contact No</label>
                </div>
                <Tooltip :title="`Contact number for communication`" />
              </div>
              <p
                v-if="submitted && errors.has('contact_no')"
                class="error_message"
              >
                {{ errors.first(`${"contact_no"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4" style="padding-right:45px;">
              <div class="input-material">
                <!-- <textarea cols="30" rows="7" placeholder="Address"></textarea> -->
                <input
                  type="text"
                  v-model="cinema_details.address"
                  id="add"
                  name="address"
                  placeholder="."
                  v-validate="{ required: 'required' }"
                />
                <label for="add">Address</label>
              </div>
              <p
                v-if="submitted && errors.has('address')"
                class="error_message"
              >
                {{ errors.first(`${"address"}`) }}
              </p>
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedCountry.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(country, countrykey) in Countries"
                    :key="countrykey"
                    v-on:click="onSelectHandler('country',country)"
                  >{{country.country_name}}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Countries"
                  :searchable="true"
                  :placeholder="
                    selectedCountry.label && selectedCountry.label.length > 0
                      ? selectedCountry.label
                      : 'Select Country'
                  "
                  label="country_name"
                  track-by="country_id"
                  @select="onSelectHandler('country', $event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <Tooltip :title="`Country where cinema is located`" />
              </div>
              <p
                v-if="submitted && selectedCountry.label == 'Select Country'"
                class="error_message"
              >
                Please Select Country.
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedState.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(state,stateIndex) in States"
                    :key="stateIndex"
                    href="#"
                    @click="onSelectHandler('state',state)"
                  >{{ state.state_name }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="States"
                  :searchable="true"
                  :placeholder="
                    selectedState.label && selectedState.label.length > 0
                      ? selectedState.label
                      : 'Select State'
                  "
                  label="state_name"
                  track-by="state_id"
                  @select="onSelectHandler('state', $event)"
                  :allowEmpty="true"
                  :showLabels="false"
                ></multiselect>
                <Tooltip :title="`State where cinema is located`" />
              </div>
              <!-- <p
                v-if="submitted && selectedState.label == 'Select State'"
                class="error_message"
              >Please Select State.</p>-->
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedCity.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(city,cityIndex) in Cities"
                    :key="cityIndex"
                    href="#"
                    @click="onSelectHandler('city',city)"
                  >{{ city.city_name }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Cities"
                  :searchable="true"
                  :placeholder="
                    selectedCity.label && selectedCity.label.length > 0
                      ? selectedCity.label
                      : 'Select City'
                  "
                  label="city_name"
                  track-by="city_id"
                  @select="onSelectHandler('city', $event)"
                  :allowEmpty="true"
                  :showLabels="false"
                ></multiselect>
                <Tooltip :title="`City where cinema is located`" />
              </div>
              <!-- <p
                v-if="submitted && selectedCity.label == 'Select City'"
                class="error_message"
              >Please Select City.</p>-->
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.pincode"
                    id="pincode"
                    placeholder="."
                    name="pincode"
                    v-validate="'alpha_num|max:10'"
                  />
                  <label for="pincode">Pincode</label>
                </div>
                <Tooltip :title="`ZipCode of cinema location`" />
              </div>
              <p
                v-if="submitted && errors.has('pincode')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"pincode"}`) }}
                <!-- <p class="error_msg">Invalid Entry</p> -->
              </p>
            </div>
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.latitude"
                    id="latitude_setup"
                    placeholder="."
                    name="latitude_setup"
                    v-validate="'decimal'"
                  />
                  <!-- v-validate="{required: 'required', regex:'^[0-9]*\\.[0-9]*\\ [a-zA-Z]$'}" -->
                  <label for="lati">Latitude</label>
                </div>
                <Tooltip :title="`Latitude of cinema location`" />
              </div>
              <p
                v-if="submitted && errors.has('latitude_setup')"
                class="error_message"
              >
                {{ errors.first(`${"latitude_setup"}`) }}
              </p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.longitude"
                    id="longitude_setup"
                    placeholder="."
                    name="longitude_setup"
                    v-validate="'decimal'"
                  />
                  <!-- v-validate="{required: 'required', regex:'^[0-9]*\\.[0-9]*\\ [a-zA-Z]$'}" -->
                  <label for="longi">Longitude</label>
                </div>
                <Tooltip :title="`Longitude of cinema location`" />
              </div>
              <p
                v-if="submitted && errors.has('longitude_setup')"
                class="error_message"
              >
                {{ errors.first(`${"longitude_setup"}`) }}
              </p>
            </div>
            <!--
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    v-model="cinema_details.no_of_screens"
                    id="nos"
                    placeholder="."
                    name="number of screens"
                    v-validate="'required|numeric'"
                  />
                  <label for="nos">No Of Screens</label>
                </div>
                <Tooltip :title="`No. of screens in cinema.`"  />
              </div>
              <p v-if="submitted && errors.has('number of screens')" class="error_message">
                {{ errors.first(`${'number of screens'}`)}}
              </p>
            </div>-->

            <!-- <ol class="d-flex" style="list-style:none">
            <li
              class="px-5"
              :style="{color:  current_cinema_index == noc ? 'green':''}"
              v-for="(noc,nocKey) in parseInt(noOfCinemas)"
              :key="nocKey"
            >{{ noc }}</li>
            </ol>-->

            <div class="col-md-12 mt-5 text-center">
              <div class="d-flex justify-content-center">
                <router-link
                  to="setup-organization"
                  class="btn-outline-blue-lg w-25 mr-1"
                  >Back</router-link
                >
                <router-link
                  v-if="IsUpdate"
                  to="cinema-configuration"
                  class="btn-outline-blue-lg w-25 mr-1"
                  >Next</router-link
                >
                <router-link
                  to
                  @click.native="onSkip()"
                  class="btn-blue-lg w-25 mr-1"
                  >Skip</router-link
                >
                <router-link
                  to
                  v-on:click.native="onSubmit()"
                  class="btn-blue-lg w-25"
                  >{{ BtnText }}</router-link
                >
              </div>

              <!-- add-screens -->
              <!-- v-on:click.native="onSubmit()" -->
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import saveState from "vue-save-state";

export default {
  // name: "Add Cinema",
  mixins: [saveState],
  data() {
    return {
      SelectedCountryCode: "Country Code",
      submitted: false,
      BtnText: "Next",
      IsUpdate: false,
      // current_cinema_index: 1,
      cinema_details: {
        cine_name: "",
        registration_number: "",
        license_number: "",
        email_id: "",
        contact_number: "",
        address: "",
        pincode: "",
        latitude: "",
        longitude: ""
        // no_of_screens: ""
      },
      selectedCountry: {
        label: "Select Country",
        value: ""
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      selectedState: {
        label: "Select State",
        value: ""
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },
      selectedCity: {
        label: "Select City",
        value: ""
      },
      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      cinemas_array: []
    };
  },
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    }
  },
  mounted() {
    this.getCountriesList();
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: "Add Cinema"
      };
    },
    onSkip: function() {
      this.$router.push({
        path: "setup-add-user"
      });
      this.$store.dispatch("setCinemaArray", this.cinemas_array);
    },
    onSelectHandler: function(type, value, index) {
      if (type == "country") {
        this.selectedCountry.label = value.country_name;
        this.selectedCountry.value = value.country_id;
        this.cinema_details["country"] = value.country_id;

        this.getStatesList(value.country_id);
      } else if (type == "countrycode") {
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "state") {
        this.selectedState.label = value.state_name;
        this.selectedState.value = value.state_id;
        this.cinema_details["state"] = value.state_id;

        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selectedCity.label = value.city_name;
        this.selectedCity.value = value.city_id;
        this.cinema_details["city"] = value.city_id;
      }
    },
    getCountriesList: function() {
      this.Countries = [];
      this.options = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getStatesList: function(country_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCitiesList: function(state_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    ResetForm: function() {
      this.cinema_details = {
        cine_name: "",
        registration_number: "",
        license_number: "",
        email_id: "",
        contact_number: "",
        address: "",
        pincode: "",
        latitude: "",
        longitude: ""
        // no_of_screens: ""
      };
      this.selectedCountry = {
        label: "Select Country",
        value: ""
      };
      this.selectedState = {
        label: "Select State",
        value: ""
      };
      this.selectedCity = {
        label: "Select City",
        value: ""
      };
    },
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            cinema_details: this.cinema_details
          };
          payload.configHeaders = {
            headers: {
              "content-type": "application/json",
              Authorization: window.localStorage.getItem("AUTH_KEY")
            }
          };
          SetupService.AddCinema(payload)
            .then(result => {
              const { data } = result;
              if (data.status) {
                this.BtnText = "Update";
                this.IsUpdate = true;
                window.localStorage.setItem(
                  "CURRENT_CINEMA_ID",
                  data.cinema_id || 1
                );
                console.log(
                  "CURRENT_CINEMA_ID ",
                  window.localStorage.getItem("CURRENT_CINEMA_ID")
                );

                // if (
                //   this.current_cinema_index == this.$store.getters.NO_OF_CINEMAS ||
                //   1
                // ) {
                //   this.$store.dispatch(
                //     "setNumberOfScreens",
                //     this.cinema_details.no_of_screens
                //   );
                // this.$store.dispatch(
                //   "setNoOfScreens",
                //   this.cinema_details.no_of_screens
                // );
                this.$router.push({
                  path: "cinema-configuration"
                });
                // } else {
                //   this.cinemas_array.push({
                //     cine_name: this.cinema_details.cinema_name,
                //     cine_id: data.cinema_id,
                //     no_of_screens: this.cinema_details.no_of_screens
                //   });
                //   this.ResetForm();
                //   this.current_cinema_index++;
                // }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(err => {
              this.$toasted.show(err);
            });
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Installation/addCinema.vue